import { Component, OnInit, ViewEncapsulation, forwardRef, ElementRef, Renderer, Injector } from '@angular/core';
import { ToggleOption, BaseAbstractControl } from 'moh-package';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'moh-survivors-claimer',
  templateUrl: './survivors-claimer.component.html',
  styleUrls: ['./survivors-claimer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SurvivorsClaimerComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SurvivorsClaimerComponent) }]
})

export class SurvivorsClaimerComponent extends BaseAbstractControl implements OnInit {

  slideToggleOptions: ToggleOption[];

  constructor(injector: Injector) {

    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup();

    this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      IDNumber: new FormControl('', []),
      Email: new FormControl('', []),
      PhoneNumber: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      Closeness: new FormControl(0, []),
      HadRemarried: new FormControl(false, []),
      Address: new FormControl('', []),
      BankAccountDetails: new FormControl('', [])
    });
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors-claimer/survivors-claimer.component.ts